import { LevelBadge } from "./Badges";

export default function TeamModal({ team, onClose }) {
  if (!team) return null;
  return (
    <div
      style={{ position: "fixed", inset: 0, background: "#000000cc", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background: "#111827", border: `1px solid ${team.colour}`, borderRadius: 18, padding: 28, maxWidth: 520, width: "100%", maxHeight: "90vh", overflowY: "auto", position: "relative" }}
      >
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: team.colour, borderRadius: "18px 18px 0 0" }} />
        <button onClick={onClose} style={{ position: "absolute", top: 14, right: 16, background: "#1f2937", border: "none", color: "#9ca3af", borderRadius: 8, padding: "4px 10px", cursor: "pointer", fontSize: 16 }}>✕</button>

        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
          {team.badge_url
            ? <img src={team.badge_url} alt={team.club} style={{ width: 56, height: 56, borderRadius: "50%", objectFit: "cover", border: "2px solid #1f2937", background: "#1f2937" }} onError={e => { e.target.style.display="none"; e.target.nextSibling.style.display="inline"; }} />
            : null}
          <span style={{ fontSize: 40, display: team.badge_url ? "none" : "inline" }}>{team.badge || "⚽"}</span>
          <div>
            <div style={{ color: "#f9fafb", fontFamily: "'Oswald', sans-serif", fontSize: 22, fontWeight: 700 }}>{team.club}</div>
            <div style={{ color: "#6b7280", fontSize: 12 }}>{team.town}, {team.region}</div>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 16 }}>
          {[["Age Group", team.ageGroup], ["Day", team.day], ["League", team.league], ["Division", team.division], ["Posted", team.posted]].map(([k, v]) => (
            <div key={k} style={{ background: "#1f2937", borderRadius: 10, padding: "10px 14px", gridColumn: k === "League" ? "1 / -1" : "auto" }}>
              <div style={{ color: "#4b5563", fontSize: 10, marginBottom: 2 }}>{k.toUpperCase()}</div>
              <div style={{ color: "#f3f4f6", fontSize: 13, fontWeight: 600 }}>{v}</div>
            </div>
          ))}
        </div>

        <div style={{ marginBottom: 14 }}>
          <div style={{ color: "#6b7280", fontSize: 11, marginBottom: 6 }}>ABILITY LEVEL</div>
          <LevelBadge level={team.level} />
          <p style={{ color: "#d1d5db", fontSize: 13, lineHeight: 1.6, marginTop: 10 }}>{team.levelDesc}</p>
        </div>

        <div style={{ marginBottom: 18 }}>
          <div style={{ color: "#6b7280", fontSize: 11, marginBottom: 8 }}>POSITIONS NEEDED</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {team.positions.map(p => (
              <span key={p} style={{ background: `${team.colour}22`, color: team.colour, border: `1px solid ${team.colour}44`, borderRadius: 20, padding: "5px 14px", fontSize: 12, fontWeight: 700 }}>{p}</span>
            ))}
          </div>
        </div>

        <div style={{ background: "#1f2937", borderRadius: 12, padding: "16px 18px", marginBottom: 6 }}>
          <div style={{ color: "#6b7280", fontSize: 11, marginBottom: 8 }}>CONTACT THE MANAGER</div>
          <div style={{ color: "#f3f4f6", fontSize: 13, marginBottom: 6 }}>✉️ {team.contact}</div>
          <div style={{ color: "#f3f4f6", fontSize: 13 }}>📞 {team.phone}</div>
        </div>

        <button style={{ width: "100%", background: team.colour, color: "#fff", border: "none", borderRadius: 10, padding: "13px 0", fontFamily: "'Oswald', sans-serif", fontWeight: 700, fontSize: 16, cursor: "pointer", marginTop: 14, letterSpacing: 1 }}>
          REGISTER INTEREST
        </button>
      </div>
    </div>
  );
}
